import { createContext, useContext, type ReactNode } from 'react'
import { usePinnedCards, type PinnedCard } from '@/hooks/usePinnedCards'
import type { Layout } from 'react-grid-layout'

interface PinnedCardsContextType {
  cards: PinnedCard[]
  pinCard: (question: string, answer: string, chart?: unknown, eventId?: number | null) => void
  unpinCard: (id: string) => void
  updateLayouts: (layouts: Layout[]) => void
}

const PinnedCardsContext = createContext<PinnedCardsContextType | undefined>(undefined)

export function PinnedCardsProvider({ children }: { children: ReactNode }) {
  const value = usePinnedCards()
  return <PinnedCardsContext.Provider value={value}>{children}</PinnedCardsContext.Provider>
}

export function usePinnedCardsContext() {
  const ctx = useContext(PinnedCardsContext)
  if (!ctx) throw new Error('usePinnedCardsContext must be inside PinnedCardsProvider')
  return ctx
}
